import { useMutation } from '@tanstack/react-query';
import { postProcessedTimesheetEntry } from '../Services/ProcessedTimesheetService';

const usePostProcessedTimeSheetEntry = (options = {}) =>
    useMutation(postProcessedTimesheetEntry, options);

export default usePostProcessedTimeSheetEntry;
